import { isWiseUiEnabled } from 'config/wiseUi';

import LegacyBlog from './Blog';
import WiseBlog from 'components/wise/WiseBlog';

const Blog = isWiseUiEnabled() ? WiseBlog : LegacyBlog;

export default Blog;
